import { ComponentPropsWithoutRef } from 'react'

import { Listbox } from '@headlessui/react'
import { clsx } from 'clsx'

import { SvgIcon } from '../Icon/SvgIcon.js'
import {
  inputAriaExpandedStyles,
  inputIconStyles,
  inputStyles,
} from '../Input/index.js'
import { useFloatingContext } from '../utils/floating/index.js'
import { useSelect } from './SelectContext.js'

export type SelectButtonProps = ComponentPropsWithoutRef<'button'> & {
  clearable?: boolean
  onCleared?: () => void
}

export const SelectButton = ({
  children,
  className,
  placeholder,
  clearable,
  onCleared,
  ...rest
}: SelectButtonProps) => {
  const { invalid, disabled } = useSelect()
  const { reference } = useFloatingContext()

  // TODO support compact size
  const size = 'default'
  const showClearButton = clearable && children

  return (
    <div ref={reference}>
      <Listbox.Button
        className={clsx(
          inputStyles({
            size,
            invalid,
            disabled,
            className,
          }),
          inputAriaExpandedStyles({ invalid }),
          'pe-10 text-start cursor-default',
        )}
        {...rest}
      >
        {() => (
          <>
            <span className="block truncate">
              {children || (
                <div className="text-content-disabled text-label-md">
                  {placeholder || '\u00A0'}
                </div>
              )}
            </span>
            {!showClearButton ? (
              <span
                className={clsx(
                  'absolute inset-y-0 end-0 flex items-center pe-2 pointer-events-none',
                )}
              >
                <SvgIcon
                  className={inputIconStyles({ size })}
                  aria-hidden="true"
                  name="selector"
                />
              </span>
            ) : (
              <button
                type="button"
                className="absolute inset-y-0 end-0 flex items-center px-2 rounded-base"
                aria-label="clear selection"
                onClick={e => {
                  e.stopPropagation()
                  onCleared?.()
                }}
              >
                <SvgIcon
                  className={inputIconStyles({ size })}
                  aria-hidden="true"
                  name="close"
                />
              </button>
            )}
          </>
        )}
      </Listbox.Button>
    </div>
  )
}
